import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import {
  GET_RESERVATIONLIST,
  GET_ADDRESERVATION,
  GET_UPDATERESERVATION,
  GET_RESERVATIONDETAILS,
  GET_BOOKINGREPORTDOWNLOAD,
  GET_CANCELREASON,
  GET_BOOKINGBUFFERTIME,
  GET_AIRPORTTERMINALLIST,
  GET_NOTIFICATIONRECIPIENTS,
  SEND_NOTIFICATIONS,
  MARK_TRIP_NO_SHOW,
  EDIT_DUTY_SLIP,
  GET_ALL_CITIES,
  GET_RATE_CARDS_V2,
  GET_RATE_ESTIMATE,
  CANCEL_PAYMENT_LINK,
  GET_TOLL_CHARGES,
  ADD_TOLL_CHARGE,
  UPDATE_TOLL_CHARGE,
  DELETE_TOLL_CHARGE,
} from "resources/actionTypes";
import {
  getReservationListService,
  addReservation,
  updateReservation,
  getReservationDetailsService,
  getCancelReasonService,
  getBookingBufferTimeService,
  getAirportTerminalListService,
  getNotificationRecipientsService,
  sendNotificationsService,
  markTripAsNoShowService,
  editDutySlipService,
  getAllCitiesService,
  getRateCardsV2Service,
  getRateEstimateService,
  cancelPaymentLinkService,
  getTollChargesService,
  addTollChargeService,
  updateTollChargeService,
  deleteTollChargeService,
} from "services/Reservation";
import {
  getReservationList,
  getReservationDetails,
} from "redux/actions/reservationAction";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* getDocumentExport(action) {
  const payload = action.payload || {};
  const bokingListExport = yield call(getReservationListService, payload);
  if (bokingListExport.success) {
    yield put({
      type: GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_SUCCESS,
    });
    if (payload?.export) {
      toast.success(bokingListExport.message);
    }
  } else {
    yield put({
      type: GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_FAILED,
      message: bokingListExport.message,
    });
    toast.error(bokingListExport?.message || "Fetching Document list Failed");
  }
}

export function* getDocumentExportWatcher() {
  yield takeEvery(
    GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_REQUESTED,
    getDocumentExport,
  );
}

function* fetchGetReservationList(action) {
  const payload = action.payload || {};
  const reservationList = yield call(getReservationListService, payload);
  if (reservationList.success) {
    yield put({
      type: GET_RESERVATIONLIST.GET_RESERVATIONLIST_SUCCESS,
      reservationList: reservationList,
    });
  } else {
    yield put({
      type: GET_RESERVATIONLIST.GET_RESERVATIONLIST_FAILED,
      message: reservationList.message,
    });
    toast.error(reservationList?.message || "Fetching Reservation list Failed");
  }
}

export function* getReservationListWatcher() {
  yield takeEvery(
    GET_RESERVATIONLIST.GET_RESERVATIONLIST_REQUESTED,
    fetchGetReservationList,
  );
}

function* fetchGetReservationDetails(action) {
  const payload = action.payload || {};
  const reservationDetails = yield call(getReservationDetailsService, payload);
  if (reservationDetails.success) {
    yield put({
      type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_SUCCESS,
      reservationDetails: reservationDetails,
    });
  } else {
    yield put({
      type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_FAILED,
      message: reservationDetails.message,
    });
    toast.error(
      reservationDetails?.message || "Fetching Reservation details Failed",
    );
  }
}

export function* getReservationDetailsWatcher() {
  yield takeEvery(
    GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED,
    fetchGetReservationDetails,
  );
}

function* fetchAddReservation(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const addReservationList = yield call(
    addReservation,
    payload.reservationData,
  );

  if (addReservationList.success) {
    yield put({
      type: GET_ADDRESERVATION.GET_ADDRESERVATION_SUCCESS,
      addReservationList: addReservationList,
    });
    toast.success(addReservationList.message);
    payload.setConfirmModal();
    store.dispatch(onLoaderTrigger(false));
  } else {
    yield put({
      type: GET_ADDRESERVATION.GET_ADDRESERVATION_FAILED,
      message: addReservationList.message,
    });
    toast.error(addReservationList?.message || "Adding Reservation Failed");
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* addReservationSaga() {
  yield takeEvery(
    GET_ADDRESERVATION.GET_ADDRESERVATION_REQUESTED,
    fetchAddReservation,
  );
}

//Update Reservation
function* updateReservationSaga(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const updateReservationData = yield call(
    updateReservation,
    payload?.updateReservationData,
    payload?.id,
  );
  if (updateReservationData.success) {
    yield put({
      type: GET_UPDATERESERVATION.GET_UPDATERESERVATION_SUCCESS,
      updateReservationData: updateReservationData,
    });
    toast.success(
      updateReservationData?.message || "Updating Reservation Successfully",
    );
    store.dispatch(onLoaderTrigger(false));
    if (payload?.navigate === "listPage") {
      store.dispatch(getReservationList({ pageSize: 10 }));
    } else if (payload?.navigate === "details") {
      store.dispatch(getReservationDetails(payload?.updateReservationData?.id));
    } else {
      payload.navigate(`/reservation`);
    }
  } else {
    yield put({
      type: GET_UPDATERESERVATION.GET_UPDATERESERVATION_FAILED,
      message: updateReservationData.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(
      updateReservationData?.message || "Updating Reservation failed",
    );
  }
}

export function* onUpdateReservationWatcher() {
  yield takeEvery(
    GET_UPDATERESERVATION.GET_UPDATERESERVATION_REQUESTED,
    updateReservationSaga,
  );
}

function* fetchGetCancelReason(action) {
  const payload = action.payload || {};
  const cancelReason = yield call(getCancelReasonService, payload);
  if (cancelReason.success) {
    yield put({
      type: GET_CANCELREASON.GET_CANCELREASON_SUCCESS,
      cancelReason: cancelReason,
    });
  } else {
    yield put({
      type: GET_CANCELREASON.GET_CANCELREASON_FAILED,
      message: cancelReason.message,
    });
    toast.error(cancelReason?.message || "Fetching Cancel Reason Failed");
  }
}

export function* getCancelReasonWatcher() {
  yield takeEvery(
    GET_CANCELREASON.GET_CANCELREASON_REQUESTED,
    fetchGetCancelReason,
  );
}

//get pre booking buffer time
function* getBookingBufferTime(action) {
  const payload = action.payload || {};
  const bufferTime = yield call(getBookingBufferTimeService, payload);
  if (bufferTime.success) {
    yield put({
      type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_SUCCESS,
      bufferTime: bufferTime,
    });
  } else {
    yield put({
      type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_FAILED,
      message: bufferTime.message,
    });
    toast.error(bufferTime?.message || "Fetching Booking Buffer Time Failed");
  }
}

export function* getBookingBufferTimeWatcher() {
  yield takeEvery(
    GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED,
    getBookingBufferTime,
  );
}

//get airport Terminal list
function* getAirportTerminalList(action) {
  const payload = action.payload || {};
  const airportListDetails = yield call(getAirportTerminalListService, payload);
  if (airportListDetails.success) {
    yield put({
      type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_SUCCESS,
      airportTerminalsDetails: airportListDetails,
    });
  } else {
    yield put({
      type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_FAILED,
      message: airportListDetails.message,
    });
    toast.error(airportListDetails?.message || "Fetching Buffer Time Failed");
  }
}

export function* getAirportTerminalListWatcher() {
  yield takeEvery(
    GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED,
    getAirportTerminalList,
  );
}

// Get Notification Recipients
// function* fetchNotificationRecipients(action) {
//   const tripId = action.payload;
//   store.dispatch(onLoaderTrigger(true));
//   const recipientsData = yield call(getNotificationRecipientsService, tripId);
//   if (recipientsData.success) {
//     yield put({
//       type: GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_SUCCESS,
//       notificationRecipients: recipientsData,
//     });
//   } else {
//     yield put({
//       type: GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_FAILED,
//       message: recipientsData.message,
//     });
//     toast.error(
//       recipientsData?.message || "Fetching Notification Recipients Failed",
//     );
//   }
//   store.dispatch(onLoaderTrigger(false));
// }

function* fetchNotificationRecipients(action) {
  const { tripId, notificationType } = action.payload;
  store.dispatch(onLoaderTrigger(true));
  const recipientsData = yield call(
    getNotificationRecipientsService,
    tripId,
    notificationType,
  );
  if (recipientsData.success) {
    yield put({
      type: GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_SUCCESS,
      notificationRecipients: recipientsData,
    });
  } else {
    yield put({
      type: GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_FAILED,
      message: recipientsData.message,
    });
    toast.error(
      recipientsData?.message || "Fetching Notification Recipients Failed",
    );
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* getNotificationRecipientsWatcher() {
  yield takeEvery(
    GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_REQUESTED,
    fetchNotificationRecipients,
  );
}

// Send Notifications
// function* sendNotificationsSaga(action) {
//   const { tripId, payload, onSuccess } = action.payload || {};
//   store.dispatch(onLoaderTrigger(true));
//   const sendNotificationsData = yield call(
//     sendNotificationsService,
//     tripId,
//     payload,
//   );
//   if (sendNotificationsData.success) {
//     yield put({
//       type: SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_SUCCESS,
//       sendNotificationsData: sendNotificationsData,
//     });
//     // toast.success(
//     //   sendNotificationsData?.message || "Notifications sent successfully",
//     // );
//     if (onSuccess) onSuccess();
//   } else {
//     yield put({
//       type: SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_FAILED,
//       message: sendNotificationsData.message,
//     });
//     toast.error(
//       sendNotificationsData?.message || "Sending Notifications Failed",
//     );
//   }
//   store.dispatch(onLoaderTrigger(false));
// }

function* sendNotificationsSaga(action) {
  const { tripId, payload, onSuccess } = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const sendNotificationsData = yield call(
    sendNotificationsService,
    tripId,
    payload,
  );
  if (sendNotificationsData.success) {
    yield put({
      type: SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_SUCCESS,
      sendNotificationsData: sendNotificationsData,
    });
    if (onSuccess) onSuccess();
  } else {
    yield put({
      type: SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_FAILED,
      message: sendNotificationsData.message,
    });
    toast.error(
      sendNotificationsData?.message || "Sending Notifications Failed",
    );
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* sendNotificationsWatcher() {
  yield takeEvery(
    SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_REQUESTED,
    sendNotificationsSaga,
  );
}

function* fetchMarkTripAsNoShow(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};

  const markNoShowResponse = yield call(
    markTripAsNoShowService,
    payload.noShowData,
  );

  if (markNoShowResponse.success) {
    yield put({
      type: MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_SUCCESS,
      markNoShowData: markNoShowResponse,
    });
    toast.success(
      markNoShowResponse?.message || "Trip marked as No-Show successfully",
    );
    store.dispatch(onLoaderTrigger(false));

    // Refresh details for both pages
    if (
      payload?.pageType === "details" ||
      payload?.pageType === "manageInvoicePage"
    ) {
      store.dispatch(getReservationDetails(payload?.noShowData?.tripId));
    }

    // Close modal using callback
    if (payload?.setModal) {
      payload.setModal();
    }
  } else {
    yield put({
      type: MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_FAILURE,
      message: markNoShowResponse.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(markNoShowResponse?.message || "Marking No-Show Failed");
  }
}

export function* markTripAsNoShowWatcher() {
  yield takeEvery(
    MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_REQUEST,
    fetchMarkTripAsNoShow,
  );
}

// ADD THIS NEW SAGA:
function* fetchEditDutySlip(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};

  const editResponse = yield call(
    editDutySlipService,
    payload.tripId,
    payload.editData,
  );

  if (editResponse.success) {
    yield put({
      type: EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_SUCCESS,
      payload: editResponse,
    });
    toast.success(editResponse?.message || "Duty slip updated successfully");
    store.dispatch(onLoaderTrigger(false));

    // Refresh trip details
    store.dispatch(getReservationDetails(payload.tripId));

    // Close modal using callback
    if (payload?.setModal) {
      payload.setModal();
    }
  } else {
    yield put({
      type: EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_FAIL,
      message: editResponse.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(editResponse?.message || "Updating Duty Slip Failed");
  }
}

export function* editDutySlipWatcher() {
  yield takeEvery(EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_REQUEST, fetchEditDutySlip);
}

function* fetchAllCities(action) {
  const allCities = action.payload;
  const citiesRes = yield call(getAllCitiesService, allCities);
  if (citiesRes.success) {
    yield put({
      type: GET_ALL_CITIES.GET_ALL_CITIES_SUCCESS,
      allCitiesList: citiesRes,
    });
  } else {
    yield put({
      type: GET_ALL_CITIES.GET_ALL_CITIES_FAILED,
      message: citiesRes.message,
    });
    toast.error(citiesRes?.message || "Fetching Cities Failed");
  }
}

export function* getAllCitiesWatcher() {
  yield takeEvery(GET_ALL_CITIES.GET_ALL_CITIES_REQUESTED, fetchAllCities);
}

function* fetchRateCardsV2(action) {
  const payload = action.payload || {};
  const rateCardsRes = yield call(getRateCardsV2Service, payload);
  if (rateCardsRes.success) {
    yield put({
      type: GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_SUCCESS,
      rateCardsV2List: rateCardsRes,
    });
  } else {
    yield put({
      type: GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_FAILED,
      message: rateCardsRes.message,
    });
    toast.error(rateCardsRes?.message || "Fetching Rate Cards Failed");
  }
}

export function* getRateCardsV2Watcher() {
  yield takeEvery(
    GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_REQUESTED,
    fetchRateCardsV2,
  );
}

function* fetchRateEstimate(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const estimateRes = yield call(getRateEstimateService, payload);
  if (estimateRes.success) {
    yield put({
      type: GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_SUCCESS,
      rateEstimateData: estimateRes,
    });
  } else {
    yield put({
      type: GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_FAILED,
      message: estimateRes.message,
    });
    toast.error(estimateRes?.message || "Fetching Rate Estimate Failed");
  }
  store.dispatch(onLoaderTrigger(false));
}

function* fetchCancelPaymentLink(action) {
  store.dispatch(onLoaderTrigger(true));
  const { tripId, reason, onSuccess } = action.payload || {};

  // Pass 'reason' as the second argument to the service
  const response = yield call(cancelPaymentLinkService, tripId, reason);

  if (response.success) {
    yield put({
      type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_SUCCESS,
    });
    toast.success(response?.message || "Payment link cancelled successfully");

    // Refresh booking details so paymentLinkStatus updates in the UI
    store.dispatch(getReservationDetails(tripId));

    if (onSuccess) {
      onSuccess();
    }
  } else {
    yield put({
      type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_FAILURE,
      message: response.message,
    });
    toast.error(response?.message || "Failed to cancel payment link");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* cancelPaymentLinkWatcher() {
  yield takeEvery(
    CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_REQUEST,
    fetchCancelPaymentLink,
  );
}

export function* getRateEstimateWatcher() {
  yield takeEvery(
    GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_REQUESTED,
    fetchRateEstimate,
  );
}

function isTollResponseSuccess(response) {
  return (
    response?.success === true ||
    response?.success === "true" ||
    response?.code === 200 ||
    response?.status === 200 ||
    response?.statusCode === 200
  );
}

function* fetchGetTollCharges(action) {
  const response = yield call(getTollChargesService, action.payload);
  if (response?.success) {
    yield put({
      type: GET_TOLL_CHARGES.GET_TOLL_CHARGES_SUCCESS,
      payload: response.data,
    });
  } else {
    yield put({
      type: GET_TOLL_CHARGES.GET_TOLL_CHARGES_FAILED,
      message: response?.message,
    });
  }
}

function* fetchAddTollCharge(action) {
  const { payload, onSuccess, onError } = action.payload;
  const response = yield call(addTollChargeService, payload);
  if (isTollResponseSuccess(response)) {
    yield put({
      type: ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_SUCCESS,
      payload: response.data,
    });
    if (onSuccess) onSuccess(response.data);
  } else {
    yield put({
      type: ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_FAILED,
      message: response?.message,
    });
    if (onError) onError(response?.message);
  }
}

function* fetchUpdateTollCharge(action) {
  const { id, payload, onSuccess, onError } = action.payload;
  const response = yield call(updateTollChargeService, id, payload);
  if (isTollResponseSuccess(response)) {
    yield put({
      type: UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_SUCCESS,
      payload: response.data,
    });
    if (onSuccess) onSuccess(response.data);
  } else {
    yield put({
      type: UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_FAILED,
      message: response?.message,
    });
    if (onError) onError(response?.message);
  }
}

function* fetchDeleteTollCharge(action) {
  const { id, onSuccess, onError } = action.payload;
  const response = yield call(deleteTollChargeService, id);
  if (isTollResponseSuccess(response)) {
    yield put({
      type: DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_SUCCESS,
      payload: id,
    });
    if (onSuccess) onSuccess();
  } else {
    yield put({
      type: DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_FAILED,
      message: response?.message,
    });
    if (onError) onError(response?.message);
  }
}

export function* getTollChargesWatcher() {
  yield takeEvery(GET_TOLL_CHARGES.GET_TOLL_CHARGES_REQUESTED, fetchGetTollCharges);
}

export function* addTollChargeWatcher() {
  yield takeEvery(ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_REQUESTED, fetchAddTollCharge);
}

export function* updateTollChargeWatcher() {
  yield takeEvery(UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_REQUESTED, fetchUpdateTollCharge);
}

export function* deleteTollChargeWatcher() {
  yield takeEvery(DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_REQUESTED, fetchDeleteTollCharge);
}
